import * as React from 'react';
import { Container, ContainerGutter } from '../container';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
const StyledFigure = styled.figure.withConfig({ displayName: "StyledFigure", componentId: "sc-1fg4r0g" }) `margin:0;`;
StyledFigure.displayName = 'StyledFigure';
export const Figure = (props) => {
    const { caption, captionAboveMedia, children } = props;
    const commonProps = getCommonProps(props);
    return (React.createElement(StyledFigure, Object.assign({}, commonProps),
        React.createElement(Container, { gutter: ContainerGutter.dynamic0020, wrap: "always" },
            caption && captionAboveMedia && React.createElement("figcaption", null, caption),
            children,
            caption && !captionAboveMedia && React.createElement("figcaption", null, caption))));
};
Figure.displayName = 'Figure';
